var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/cropper.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h1>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</h1>\n<form>\n    <div class=\"form standard-form\">\n        <div class=\"form-body\">\n            <div class=\"span-100\">\n                <div class=\"form-row\">\n                    <div class=\"canvas\" style=\"margin-right:15px\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div style=\"clear:both\">\n        <input class=\"submit-btn btn span2\" type=\"submit\" value=\"Save\">\n    </div>\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/cropper.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/cropper.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/cropper.html
// module chunks = main